// Fahrer-Ablehnungssperre (docs/general/fahrer_ablehnungssperre_konzept.md)
// Gemeinsamer Helfer für alle Oberflächen (LiveMap, Fahrerverwaltung, Dashboard).
// Es gibt KEIN eigenes Status-Feld — der Sperr-Zustand wird zur Anzeigezeit aus
// dem autoritativen Timestamp `fahrerSperreBis` abgeleitet.

/**
 * Wandelt einen Firestore-Timestamp / Date / Millis in Millisekunden um.
 * @returns {number|null}
 */
export const toMillis = (value) => {
  if (value == null) return null;
  if (typeof value === 'number') return value;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  if (value instanceof Date) return value.getTime();
  return null;
};

/**
 * True, wenn der Fahrer aktuell gesperrt ist (fahrerSperreBis liegt in der Zukunft).
 * @param {object} driver
 * @returns {boolean}
 */
export const isDriverBlocked = (driver) => {
  const ms = toMillis(driver?.fahrerSperreBis);
  return ms != null && ms > Date.now();
};

/**
 * Restdauer der Sperre in Millisekunden (0, wenn nicht gesperrt).
 * @param {object} driver
 * @returns {number}
 */
export const driverBlockRemainingMs = (driver) => {
  const ms = toMillis(driver?.fahrerSperreBis);
  if (ms == null) return 0;
  return Math.max(0, ms - Date.now());
};
